export default [
  {
    path: '/app/defines/departments',
    name: 'Departments',
    component: () => import('@/views/Defines/Departments/Index.vue'),
    meta: {
      pageTitle: 'Departmanlar',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'DEPARTMENTS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/defines/departments/add',
    name: 'DepartmentsAdd',
    component: () => import('@/views/Defines/Departments/Add.vue'),
    meta: {
      pageTitle: 'Departmanlar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/departments',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'DEPARTMENTS_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/defines/departments/edit/:id',
    name: 'DepartmentsEdit',
    component: () => import('@/views/Defines/Departments/Edit.vue'),
    meta: {
      pageTitle: 'Departmanlar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/departments',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'DEPARTMENTS_EDIT',
      action: 'read',
    },
  },
]
